import axios from 'axios'
import store from '../store'

let querystring = require('querystring')
const hostName = process.env.NODE_ENV === 'production' ? 'http://api-team.marinescu.xyz/' : 'https://localhost:44364/'

let isAlreadyFetchingAccessToken = false
let subscribers = []

function getOauthHeader() {
  let authData = store.getters.authData;
  let token = btoa(authData.client + ':' + authData.secret);
  return {
    "Authorization": "Basic " + token,
    'Content-Type': 'application/x-www-form-urlencoded',
    "Accept": "application/json"
  };
}

function addSubscriber(callback) {
  subscribers.push(callback)
}


export default () => {
  let crtAxios = axios.create({
    baseURL: hostName
  });


  crtAxios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {

    let authData = store.getters.authData;
    const { config, response: { status } } = error
    const originalRequest = config

    if (status === 401) {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true
        
        axios.create({
          baseURL: hostName
        }).post('api/token',
          querystring.stringify({
            'grant_type': 'refresh_token',
            'scope': 'read',
            'refresh_token': authData.refresh_token 
          }),
          {
            headers: getOauthHeader()
          }).then(function (response) {
            let newData = {
              access_token: response.data.access_token,
              client: authData.client,
              expires_in: response.data.expires_in,
              refresh_token: response.data.refresh_token,
              secret: authData.secret,
              token_type: response.data.token_type
            };
            window.vm.$store.dispatch('LOGIN', newData);
          }).catch(function () {
            window.vm.$store.dispatch('LOGOUT');
            window.vm.$router.push('/account/login');
          }).finally(function () {
            isAlreadyFetchingAccessToken = false;
            while(subscribers.length > 0) {
              let s = subscribers.pop();
              s();
            }
          });
      }

      const retryOriginalRequest = new Promise((resolve) => {
        addSubscriber(() => {
          let authData = store.getters.authData;
          originalRequest.headers.Authorization = 'Bearer ' + authData.access_token
          resolve(axios(originalRequest))
        })
      })
      return retryOriginalRequest
    }
    return Promise.reject(error)
  })

  return crtAxios;
}